import ConnectionsEffectIcon from '@/components/Common/ConnectionsEffectIcon';
import AgentSignature from '@/components/Common/AgentSignature';

// @vue/component
export default {
  name: 'ConnectionsAttemptsHistoryList',

  components: {
    ConnectionsEffectIcon,
    AgentSignature,
  },

  props: {
    connectionUuid: {
      type: String,
      default: '',
    },
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes(['connections/getHistoryList']);
    },
    attemptsList() {
      return this.$store.getters['connections/historyList'];
    },
  },

  created() {
    if (this.connectionUuid) this.$store.dispatch('connections/getHistoryList', { wh1_uuid: this.connectionUuid });
  },
};
